module.exports = __webpack_public_path__ + "static/img/dashboard_logo_right.3149fd5.svg";


//////////////////
// WEBPACK FOOTER
// ./static/prism/images/dashboard_logo_right.svg
// module id = ydnr
// module chunks = 75